import MerchantDirectApplications from "../components/merchant-direct-applications/merchant-direct-applications";

import { PERMISSIONS, USER_TYPE } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/**
 *
 * @returns 加盟店申請（直接）情報一覧画面
 */
const MerchantDirectApplicationsPage = (): JSX.Element => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.APPLY, USER_TYPE.MERCHANT_GEN);
  return <MerchantDirectApplications />;
};

export default MerchantDirectApplicationsPage;
